















































import { Input, Form, FormItem, Button } from 'element-ui'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'

import ChangePasswordFormModel from '@/models/change-password-form'
import ErrorEntities from '@/models/error-entities'

@Component({
  components: {
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
  },
})
export default class ChangePasswordForm extends Vue {
  @Prop({
    default: () => {
      return {}
    },
  })
  serverErrors!: ErrorEntities
  @Ref() readonly changePasswordFormElement!: Form

  submitDisabled = false

  rules = {
    currentPassword: [{ required: true, message: 'Old password is required' }],
    password: [
      { required: true, message: 'New password is required', trigger: 'blur' },
      {
        min: 8,
        message: 'New password should be at least 8 characters long',
        trigger: 'blur',
      },
    ],
    passwordConfirmation: [
      { required: true, message: 'New password confirmation is required' },
      {
        validator: (
          rule: any,
          value: string,
          callback: (errors?: string) => void,
        ) => {
          if (value !== this.changePasswordForm.password) {
            callback("Password confirmation doesn't match the password")
          } else {
            callback()
          }
        },
        trigger: 'blur',
      },
    ],
  }

  changePasswordForm: ChangePasswordFormModel = {
    currentPassword: '',
    password: '',
    passwordConfirmation: '',
  }

  get currentPasswordError() {
    return (
      this.serverErrors.currentPassword &&
      this.serverErrors.currentPassword[0] &&
      'Password ' + this.serverErrors.currentPassword[0]
    )
  }

  handlePasswordChange() {
    this.submitDisabled = true
    this.changePasswordFormElement.validate((isValid) => {
      if (isValid) {
        this.$emit('on-password-change', this.changePasswordForm)
      }
      this.submitDisabled = false
    })
  }

  resetForm() {
    this.changePasswordFormElement.resetFields()
  }
}
